import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_FILTER_GROUP = '/filtergroup';

export const SET_FILTER_GROUP_LOADING = 'SET_FILTER_GROUP_LOADING';
export const GO_TO_FILTER_GROUP_CREATE = 'GO_TO_FILTER_GROUP_CREATE';
export const GO_TO_FILTER_GROUP_EDIT = 'GO_TO_FILTER_GROUP_EDIT';
export const GO_TO_FILTER_GROUP_VIEW = 'GO_TO_FILTER_GROUP_VIEW';
export const GO_TO_FILTER_GROUP_COPY = 'GO_TO_FILTER_GROUP_COPY';
export const GO_TO_FILTER_GROUP_LIST = 'GO_TO_FILTER_GROUP_LIST';
export const GET_FILTER_GROUP_LIST = 'GET_FILTER_GROUP_LIST';
export const GET_FILTER_GROUP_LIST_PENDING = 'GET_FILTER_GROUP_LIST_PENDING';
export const GET_FILTER_GROUP_LIST_FULFILLED = 'GET_FILTER_GROUP_LIST_FULFILLED';
export const GET_FILTER_GROUP = 'GET_FILTER_GROUP';
export const GET_FILTER_GROUP_PENDING = 'GET_FILTER_GROUP_PENDING';
export const GET_FILTER_GROUP_FULFILLED = 'GET_FILTER_GROUP_FULFILLED';
export const CREATE_FILTER_GROUP = 'CREATE_FILTER_GROUP';
export const CREATE_FILTER_GROUP_PENDING = 'CREATE_FILTER_GROUP_PENDING';
export const CREATE_FILTER_GROUP_FULFILLED = 'CREATE_FILTER_GROUP_FULFILLED';
export const CREATE_FILTER_GROUP_REJECTED = 'CREATE_FILTER_GROUP_REJECTED';
export const UPDATE_FILTER_GROUP = 'UPDATE_FILTER_GROUP';
export const UPDATE_FILTER_GROUP_FULFILLED = 'UPDATE_FILTER_GROUP_FULFILLED';
export const UPDATE_FILTER_GROUP_REJECTED = 'UPDATE_FILTER_GROUP_REJECTED';
export const DELETE_FILTER_GROUP = 'DELETE_FILTER_GROUP';
export const DELETE_FILTER_GROUP_FULFILLED = 'DELETE_FILTER_GROUP_FULFILLED';
export const DELETE_FILTER_GROUP_REJECTED = 'DELETE_FILTER_GROUP_REJECTED';
export const SELECT_FILTER_GROUP = 'SELECT_FILTER_GROUP';
export const OPEN_FILTER_GROUP_CREATE_POPUP = 'OPEN_FILTER_GROUP_CREATE_POPUP';
export const CLOSE_FILTER_GROUP_CREATE_POPUP = 'CLOSE_FILTER_GROUP_CREATE_POPUP';

export enum FilterGroupPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export enum FilterGroupMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export interface FilterGroup {
  id: string,
  fgId: string,
  name: string,
  owner: string,
  group: string,
  access: string,
}

export interface FilterGroupPayload {
  fgId: string,
  name: string
}

export interface FilterGroupState {
  entities: FilterGroup[]
  selected: FilterGroup[],
  single: FilterGroup | null
  createdId: string | null
  ui: FilterGroupsUIState
}

export interface FilterGroupsUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToFilterGroupListAction extends AnyAction {
  type: typeof GO_TO_FILTER_GROUP_LIST
}

export interface SetFilterGroupLoadingAction extends AnyAction {
  type: typeof SET_FILTER_GROUP_LOADING
  payload: { isLoading: boolean }
}

export interface GetFilterGroupListAction extends AnyAction {
  type: typeof GET_FILTER_GROUP_LIST
  payload: AxiosPromise<ServerResponse<FilterGroup>>
}

export interface GetFilterGroupListPendingAction extends AnyAction {
  type: typeof GET_FILTER_GROUP_LIST_PENDING
  payload: null
}

export interface GetFilterGroupListFulfilledAction extends AnyAction {
  type: typeof GET_FILTER_GROUP_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<FilterGroup>>
}

export interface GetFilterGroupAction extends AnyAction {
  type: typeof GET_FILTER_GROUP
  payload: AxiosPromise<ServerResponse<FilterGroup>>
}

export interface GetFilterGroupPendingAction extends AnyAction {
  type: typeof GET_FILTER_GROUP_PENDING
  payload: null
}

export interface GetFilterGroupFulfilledAction extends AnyAction {
  type: typeof GET_FILTER_GROUP_FULFILLED
  payload: AxiosResponse<ServerResponse<FilterGroup>>
}

export interface CreateFilterGroupThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface CreateFilterGroupAction extends AnyAction {
  type: typeof CREATE_FILTER_GROUP
  payload: AxiosPromise<ServerResponse<FilterGroup>>
}

export interface CreateFilterGroupPendingAction extends AnyAction {
  type: typeof CREATE_FILTER_GROUP_PENDING
  payload: null
}

export interface CreateFilterGroupFulfilledAction extends AnyAction {
  type: typeof CREATE_FILTER_GROUP_FULFILLED
  payload: AxiosResponse<ServerResponse<FilterGroup>>
}

export interface CreateFilterGroupRejectedAction extends AnyAction {
  type: typeof CREATE_FILTER_GROUP_REJECTED
  payload: AxiosResponse<ServerResponse<FilterGroup>>
}

export interface UpdateFilterGroupThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface UpdateFilterGroupAction extends AnyAction {
  type: typeof UPDATE_FILTER_GROUP
  payload: AxiosPromise<ServerResponse<FilterGroup>>
}

export interface UpdateFilterGroupFulfilledAction extends AnyAction {
  type: typeof UPDATE_FILTER_GROUP_FULFILLED
  payload: AxiosResponse<ServerResponse<FilterGroup>>
}

export interface UpdateFilterGroupRejectedAction extends AnyAction {
  type: typeof UPDATE_FILTER_GROUP_REJECTED
  payload: AxiosResponse<ServerResponse<FilterGroup>>
}

export interface DeleteFilterGroupThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface DeleteFilterGroupAction extends AnyAction {
  type: typeof DELETE_FILTER_GROUP
  payload: AxiosPromise<ServerResponse<FilterGroup>>
}

export interface DeleteFilterGroupFulfilledAction extends AnyAction {
  type: typeof DELETE_FILTER_GROUP_FULFILLED
  payload: AxiosResponse<ServerResponse<FilterGroup>>
}

export interface DeleteFilterGroupRejectedAction extends AnyAction {
  type: typeof DELETE_FILTER_GROUP_REJECTED
  payload: AxiosResponse<ServerResponse<FilterGroup>>
}

export interface SelectFilterGroupAction extends AnyAction {
  type: typeof SELECT_FILTER_GROUP
  payload: FilterGroup[]
}

export interface OpenFilterGroupCreatePopupAction extends AnyAction {
  type: typeof OPEN_FILTER_GROUP_CREATE_POPUP
  payload: { filterGroup?: FilterGroup }
}

export interface CloseFilterGroupCreatePopupAction extends AnyAction {
  type: typeof CLOSE_FILTER_GROUP_CREATE_POPUP
}

export type FilterGroupActionTypes =
  GoToFilterGroupListAction |
  SetFilterGroupLoadingAction |
  GetFilterGroupListAction |
  GetFilterGroupListPendingAction |
  GetFilterGroupListFulfilledAction |
  GetFilterGroupAction |
  GetFilterGroupPendingAction |
  GetFilterGroupFulfilledAction |
  CreateFilterGroupAction |
  CreateFilterGroupPendingAction |
  CreateFilterGroupFulfilledAction |
  CreateFilterGroupRejectedAction |
  UpdateFilterGroupAction |
  UpdateFilterGroupFulfilledAction |
  UpdateFilterGroupRejectedAction |
  DeleteFilterGroupAction |
  DeleteFilterGroupFulfilledAction |
  DeleteFilterGroupRejectedAction |
  SelectFilterGroupAction |
  OpenFilterGroupCreatePopupAction |
  CloseFilterGroupCreatePopupAction;
